//charts
import { followerGrowthHistoryConfig } from '@/lib/analytics/charts/x/followerGrowthHistory';
import { gainedLostFollowersConfig } from '@/lib/analytics/charts/x/gainedLostFollowers';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/x/followersEvolution';
import { followersEvolutionPercentageConfig } from '@/lib/analytics/kpis/x/followersEvolutionPercentage';
//kpis
import { totalFollowersConfig } from '@/lib/analytics/kpis/x/totalFollowers';
import { SIZE_33 } from '@/lib/gridElements/size';

export const CommunityX = [
    { ...totalFollowersConfig, size: SIZE_33 },
    { ...followersEvolutionConfig, size: SIZE_33 },
    { ...followersEvolutionPercentageConfig, size: SIZE_33 },
    followerGrowthHistoryConfig,
    gainedLostFollowersConfig
];

export const requestXParams = [
    // XAccountMetrics
    'followers',
    'followers_evolution',
    'followers_evolution_percentage',
    'followers_history',
    'gained_lost_followers_history'
];
